import axios from "axios";

import config from "../utils/ConfigurationENV";

export default axios.create({
  baseURL: config.AXIOS_BASE_URL,
});

export const axiosPrivate = axios.create({
  baseURL: config.AXIOS_BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});
